import src from "IMAGE";
export default { src, width: 1038, height: 186, blurWidth: 0, blurHeight: 0};
